export { default } from "./GoogleLoginButton";



// WEBPACK FOOTER //
// ./src/design-system/atoms/GoogleLoginButton/index.jsx